import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService as ApiLogin } from 'src/app/services/login/api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  redirectUrl: any;
  baseUrl: string = environment.apiURL;

  constructor(private httpClient: HttpClient, private apiLogin: ApiLogin) { }

  public async getVoucher(highlight: boolean) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
    let params = new HttpParams();
    params = params.append("highlight", highlight);
    return this.httpClient.get<any>(`${this.baseUrl}voucher`, { headers: httpHeaders, params: params })
      .pipe(map(response => {
        return response;
      }));
  }

  public async checkVoucher(code: string) {
    const httpHeaders = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.apiLogin.getToken())
      .set('Content-Type', 'application/json');
    return this.httpClient.get<any>(`${this.baseUrl}voucher-check/${code}`, { headers: httpHeaders })
      .pipe(map(response => {
        return response;
      }));
  }

  public async setVoucher(formData: FormData) {
    const httpHeaders = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.apiLogin.getToken());
    return this.httpClient.post<any>(`${this.baseUrl}voucher-select`, formData, { headers: httpHeaders })
      .pipe(map(response => {
        return response;
      }));
  }
}
